import * as React from 'react';
import { memo } from 'react';

const SvgGlobeV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.969 17.991a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z", stroke: "currentColor", strokeWidth: 1.2, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M3.898 7.991H18.04M3.898 12.991H18.04", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.969 17.788c1.726 0 3.125-3.267 3.125-7.297 0-4.03-1.4-7.297-3.125-7.297-1.726 0-3.125 3.267-3.125 7.297 0 4.03 1.399 7.297 3.125 7.297Z", stroke: "currentColor", strokeWidth: 1.2, strokeMiterlimit: 10 })));
const Memo = memo(SvgGlobeV2);

export { Memo as default };
